import BaseAPIService from './base.service';


export default class MetadataAPIService extends BaseAPIService {
  apiBase: string | undefined;

  constructor(apiBase?: string) {
    super();
    if (apiBase) this.apiBase = apiBase;
  }

  async getMetadata() {
    try {
      const res = await super.get({ apiBase: this.apiBase, endpoint: '/api/metadata' });

      return res.json();
    } catch (err: any) {
      console.log('getMetadata::getMedias() ', err);
      throw new Error(err.message);
    }
  }

  async getMetadataById(id: string) {
    try {
      const res = await super.get({ apiBase: this.apiBase, endpoint: `/api/metadata/${id}` });

      return res.json();
    } catch (err: any) {
      console.log('getMetadataById::getMedias() ', err);
      throw new Error(err.message);
    }
  }

  async createMetadata(data: any): Promise<NFT[]> {
    try {
      const res = await super.post({
        apiBase: this.apiBase,
        endpoint: '/api/metadata',
        data: {
          data: data,
        },
      });
      return res.json();
    } catch (err: any) {
      console.log('MediaAPIService::createMedia:: ', err);
      throw new Error(err.message);
    }
  }
}
